import { useQuery } from '@tanstack/react-query';
import { QUESTIONNAIRE_DETAILS_TREE_KEY } from '../../utils/constants/queryKeys';
import { getQuestionnaireDetailsTree } from '../services/fn-api/Questionnaires';

export const useGetQuestionnaireDetailsTree = (questionnaireId: number, caseQuestionnaireId: number) => {
  return useQuery({
    queryKey: [QUESTIONNAIRE_DETAILS_TREE_KEY, questionnaireId, caseQuestionnaireId],
    queryFn: () => getQuestionnaireDetailsTree(questionnaireId, caseQuestionnaireId),
    enabled: !!questionnaireId && !!caseQuestionnaireId,
  });
};
